import actions from './actions';

const {
  LIST_ESTADO, LIST_MUNICIPIO, LIST_EMPLEADO_ESQUEMAS_CONTRACTUALES, LIST_TIPO_EMPLEADO,
  LIST_SUCURSAL_ESQUEMAS_CONTRACTUALES, LIST_SUCURSAL_ESQUEMAS_COSTOS, LIST_SERVICIOS
} = actions;

const initialState = {
  estados: [],
  municipios: [],
  empleadoEsquemasContractuales: [],
  tipoEmpleados: [],
  sucursalEsquemasContractuales: [],
  sucursalEsquemasCostos: [],
  servicios: [],
  tipoOrigenes: [
    { value: '1', label: 'Interno' },
    { value: '2', label: 'Ventas' },
    { value: '3', label: 'Convenio' },
    { value: '4', label: 'Externo' },
  ],
  generos: [
    { value: 'masculino', label: 'Masculino' },
    { value: 'femenino', label: 'Femenino' },
    { value: 'no_especificado', label: 'No especificado' },
  ],
  regimenFiscal: [
    { value: '612', label: '612 - Personas Físicas con Actividades Empresariales y Profesionales' },
    { value: '601', label: '601 - General de Ley Personas Morales' },
  ],
  categoriasServicios: [
    { value: '2', label: 'PAD' },
    { value: '3', label: 'Consulta' },
    { value: '4', label: 'Tratamientos generales' },
    { value: '5', label: 'Tratamientos PADIDE' },
    { value: '6', label: 'Radiografías' },
    { value: '7', label: 'Ortodoncia' },
    { value: '8', label: 'Odontopediatría' },
    { value: '9', label: 'Odontopediatría con especialista' },
    { value: '10', label: 'Endodoncia' },
    { value: '11', label: 'Cirugía' },
    { value: '12', label: 'Cosmética dental' },
    { value: '13', label: 'Laboratorio Especializado Suizo' },
    { value: '14', label: 'Sirconias' },
    { value: '15', label: 'Prótesis' },
    { value: '16', label: 'Implantología' },
    { value: '17', label: 'Prostodoncia' },
    { value: '18', label: 'Periodoncia' },
    { value: '19', label: 'Articulos de mostrador' },
  ],
  estadosCivil: [
    { value: 'soltero', label: 'Soltero' },
    { value: 'casado', label: 'Casado' },
    { value: 'no_especificado', label: 'No especificado' },
  ],
  formasPago: [
    { value: '1', label: 'Efectivo sin factura (PT)' },
    { value: '2', label: 'Efectivo' },
    { value: '3', label: 'Deposito bancario' },
    { value: '4', label: 'Tarjeta debito' },
    { value: '5', label: 'Tarjeta credito' },
    { value: '6', label: 'Transferencia' },
    { value: '7', label: 'Cheque' },
  ],
  tiposServicio: [
    { value: '1', label: 'Servicio' },
    { value: '2', label: 'Producto' },    
  ],
};


const catalogosReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_ESTADO:
      return {
        ...state,
        estados: data
      }
    case LIST_MUNICIPIO:
      return {
        ...state,
        municipios: data
      }
    case LIST_EMPLEADO_ESQUEMAS_CONTRACTUALES:
      return {
        ...state,
        empleadoEsquemasContractuales: data
      }
    case LIST_TIPO_EMPLEADO:
      return {
        ...state,
        tipoEmpleados: data
      }
    case LIST_SUCURSAL_ESQUEMAS_CONTRACTUALES:
      return {
        ...state,
        sucursalEsquemasContractuales: data
      }
    case LIST_SUCURSAL_ESQUEMAS_COSTOS:
      return {
        ...state,
        sucursalEsquemasCostos: data
      }
    case LIST_SERVICIOS:
      return {
        ...state,
        servicios: data
      }
    default:
      return state;
  }
};

export default catalogosReducer;
